// extracted by mini-css-extract-plugin
export default {"wrapper":"empty-note_wrapper__J1hM6","img":"empty-note_img__xeHO-","description":"empty-note_description__qC0el","button":"empty-note_button__28MTc"};